import Logo from "./logo.png";
import Person from "./person.jpg";
import Person2 from "./person2.jpg";
import Nishan from "./nishan.jpg";

export const Images = { Logo, Person, Person2, Nishan };
